// resolveOrgSidebarSection maps a URL path to the org-hub sidebar's active
// section key. The nested org sidebar is NOT re-rendered on #org-content partial
// swaps (the Buchung overview checklist CTAs and the sidebar's own links hx-get
// into #org-content), so its highlight must derive from the live URL instead of
// per-click state — which also keeps it correct across browser back/forward.
//
// `sections` is the sidebar's section vocabulary, ordered LONGEST-FIRST, passed
// from Go via data-oh-sections on the sidebar root (single source of truth:
// templates/components/org_hub_sidebar.templ's orgSidebarSectionKeysJSON). The
// longest-first order makes a multi-segment section ("booking/payments",
// "settings/integrations") win over its single-segment prefix ("booking",
// "settings"), and folds a detail route ("pricing-profiles/{id}") to its base
// ("pricing-profiles").
export function resolveOrgSidebarSection(
  path: string,
  base: string,
  sections: string[],
): string {
  if (!base || !path.startsWith(base)) return "";
  const suffix = path
    .slice(base.length)
    .replace(/^\/+/, "")
    .replace(/\/+$/, "");
  if (suffix === "") return "overview";
  for (const s of sections) {
    if (suffix === s || suffix.startsWith(s + "/")) return s;
  }
  return "";
}
